import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "view",
  id: "news"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "link-wrap" }, null, -1)
const _hoisted_7 = { class: "box-shadow right reversed nohover" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("news "),
  /*#__PURE__*/_createElementVNode("span", null, "من الاخبار")
], -1)
const _hoisted_9 = { class: "news-wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "top" }
const _hoisted_12 = { class: "img-wrap" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "title-wrap" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.posts && _ctx.posts.news && _ctx.posts.news[_ctx.activePost])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["left", _ctx.posts.news[_ctx.activePost].custom_fields.language])
          }, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.posts.news[_ctx.activePost].post_title), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.posts.news[_ctx.activePost].custom_fields.date), 1),
            _createElementVNode("img", {
              src: _ctx.posts.news[_ctx.activePost].custom_fields.image.sizes.medium_large
            }, null, 8, _hoisted_4),
            _createElementVNode("div", {
              innerHTML: _ctx.posts.news[_ctx.activePost].post_content
            }, null, 8, _hoisted_5),
            _hoisted_6
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["right", {'stopped': _ctx.scrolled}]),
            id: "newsWrap"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts.news, (post, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["post right", [post.custom_fields.language], {'chosen': index == _ctx.activePost}]),
                      onClick: $event => (_ctx.setActivePost(index))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("img", {
                              src: post.custom_fields.image.sizes.thumbnail
                            }, null, 8, _hoisted_13)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h3", null, _toDisplayString(post.post_title), 1)
                          ])
                        ])
                      ])
                    ], 10, _hoisted_10))
                  }), 256))
                ])
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}